import { render } from "./ComplementoPrivacidadPrincipal.vue?vue&type=template&id=c119091c"
const script = {}

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__